import { render, staticRenderFns } from "./EmpresasRegiaoAdmin.vue?vue&type=template&id=fb02eff8&"
import script from "./EmpresasRegiaoAdmin.vue?vue&type=script&lang=js&"
export * from "./EmpresasRegiaoAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports